/**
 * @generated SignedSource<<63f392bd3b47c748bfaa3d017614cc95>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChargePrintPDF_charge$data = {
  readonly status: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ChargePDFDocument_charge">;
  readonly " $fragmentType": "ChargePrintPDF_charge";
};
export type ChargePrintPDF_charge$key = {
  readonly " $data"?: ChargePrintPDF_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChargePrintPDF_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChargePrintPDF_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChargePDFDocument_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "86f66efc4ae1d2b549b740ea3911613f";

export default node;
